import { render, staticRenderFns } from "./SupManager.vue?vue&type=template&id=4dfb231a&scoped=true"
import script from "./SupManager.vue?vue&type=script&lang=js"
export * from "./SupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb231a",
  null
  
)

export default component.exports